import Joi from 'joi'

export const quoteFormValidation = (data) => {
	return new Joi.object({
		name: Joi.string()
			.min(1)
			.max(80)
			.required(),
		mobile: Joi.string()
			.min(10)
			.max(10)
			.required(),
		email: Joi.string()
			.email({
				tlds: false,
			})
			.required(),
		city: Joi.string().required(),
		message: Joi.string()
			.min(3)
			.max(800)
			.required(),
	}).validate(data)
}
